import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SseService } from 'src/app/services/SseService';

export interface AdminChatLeadRow {
  leadId: number;
  name: string;
  email: string;
  phone: string;
  interestMessage: string;
  sessionId: string;
  referrer: string;
  createdAt: string;
  source: string;
}

@Component({
  selector: 'app-admin-usuarios-chat',
  templateUrl: './admin-usuarios-chat.component.html',
  styleUrls: ['./admin-usuarios-chat.component.scss']
})
export class AdminUsuariosChatComponent implements OnInit {
  isLoadingLeads = false;
  displayedColumnsLeads: string[] = [
    'leadId',
    'source',
    'name',
    'email',
    'phone',
    'interestMessage',
    'sessionId',
    'referrer',
    'createdAt'
  ];
  dataSourceLeads = new MatTableDataSource<AdminChatLeadRow>([]);

  constructor(
    private sseService: SseService,
    private toastr: ToastrService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.cargarLeads();
  }

  cargarLeads(): void {
    if (this.isLoadingLeads) {
      return;
    }

    this.isLoadingLeads = true;
    this.sseService.apiGetNew('admin/listaUsuariosChat').subscribe({
      next: (data: AdminChatLeadRow[]) => {
        this.dataSourceLeads.data = Array.isArray(data) ? data : [];
        this.cdRef.markForCheck();
      },
      error: (error: any) => {
        console.error('Error al cargar leads del chat:', error);
        this.toastr.error('No fue posible cargar los registros del chat', 'Error', { timeOut: 5000 });
        this.dataSourceLeads.data = [];
        this.isLoadingLeads = false;
        this.cdRef.markForCheck();
      },
      complete: () => {
        this.isLoadingLeads = false;
        this.cdRef.markForCheck();
      }
    });
  }
}